
import {
    SET_APP_SETTINGS,
} from './types';

import { apiCallV2 } from "../../utils/api";
import toast from 'react-hot-toast';

export const GetAppSettings = (page = 1, count = 100, filter = {}, sort = null) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "settings/get-app-settings",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            count: count,
            filters: filter,
            sort: sort,
        },
    );

    dispatch({
        type: SET_APP_SETTINGS,
        data: {
            list: res.data.appSettings,
            count: res.data.count[0]["count(*)"]
        }
    })
}

export const UpdateAppSetting = (setting, value) => async (dispatch, getState) => {
    const { list, count } = getState().AppSettings;
    const res = await apiCallV2(
        "POST",
        "settings/update-app-settings",
        {
            setting: setting?.id,
            value: value,
        },
        localStorage.getItem("access-token"),
        {},
    );

    if (res.data?.status == 200) {
        toast.success("Setting Updated!");

        dispatch({
            type: SET_APP_SETTINGS,
            data: {
                list: list?.map((s) => {
                    if (s.id === setting?.id) {
                        return {
                            ...s,
                            value: value,
                        }
                    }
                    return s;
                }),
                count: count
            }
        })
    }

}

